module.exports = __webpack_public_path__ + "media/images/front/icon_04_arrow_wh-fe0186d890f232e76d3af806ff9e46e5.png";